// URLs are configuration, never a place to embed credentials or Function keys.
export function validateSignalREndpoint(value) {
  const url = new URL(value.trim());
  if (url.protocol !== 'https:' && !(url.protocol === 'http:' && ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname))) {
    throw new Error('Use HTTPS, or HTTP on localhost.');
  }
  if (url.username || url.password || url.search || url.hash) {
    throw new Error('Enter the Functions base URL without credentials, query parameters, or a fragment.');
  }
  if (/\/negotiate\/?$/i.test(url.pathname)) throw new Error('Enter the base URL without /negotiate.');
  return url.href.replace(/\/+$/, '');
}
